export const counterpartInstitution = [
    { key: "2001", participant: "BANXICO" },
    { key: "37006", participant: "BANCOMEXT" },
    { key: "37009", participant: "BANOBRAS" },
    { key: "37019", participant: "BANJERCITO" },
    { key: "37135", participant: "NAFIN" },
    { key: "37166", participant: "BaBien" },
    { key: "37168", participant: "HIPOTECARIA FED" },
    { key: "40002", participant: "BANAMEX" },
    { key: "40012", participant: "BBVA MEXICO" },
    { key: "40014", participant: "SANTANDER" },
    { key: "40021", participant: "HSBC" },
    { key: "40030", participant: "BAJIO" },
    { key: "40036", participant: "INBURSA" },
    { key: "40042", participant: "MIFEL" },
    { key: "40044", participant: "SCOTIABANK" },
    { key: "40058", participant: "BANREGIO" },
    { key: "40059", participant: "IINVEX" },
    { key: "40060", participant: "BANSI" },
    { key: "40062", participant: "AFIRME" },
    { key: "40072", participant: "BANORTE" },
    { key: "40106", participant: "BANK OF AMERICA" },
    { key: "40108", participant: "MUFG" },
    { key: "40110", participant: "JP MORGAN" },
    { key: "40112", participant: "BMONEX" },
    { key: "40113", participant: "VE POR MAS" },
    { key: "40127", participant: "AZTECA" },
    { key: "40128", participant: "AUTOFIN" },
    { key: "40129", participant: "BARCLAYS" },
    { key: "40130", participant: "COMPARTAMOS" },
    { key: "40132", participant: "MULTIVA BANCO" },
    { key: "40133", participant: "ACTINVER" },
    { key: "40136", participant: "INTERCAM BANCO" },
    { key: "40137", participant: "BANCOPPEL" },
    { key: "40138", participant: "ABC CAPITAL" },
    { key: "40140", participant: "CONSUBANCO" },
    { key: "40141", participant: "VOLKSWAGEN" },
    { key: "40143", participant: "CIBANCO" },
    { key: "40145", participant: "BBASE" },
    { key: "40147", participant: "BANKAOOL" },
    { key: "40148", participant: "PAGATODO" },
    { key: "40150", participant: "INMOBILIARIO" },
    { key: "40151", participant: "DONDE" },
    { key: "40152", participant: "BANCREA" },
    { key: "40154", participant: "BANCO COVALTO" },
    { key: "40155", participant: "ICBC" },
    { key: "40156", participant: "SABADELL" },
    { key: "40157", participant: "SHINHAN" },
    { key: "40158", participant: "MIZUHO BANK" },
    { key: "40159", participant: "BANK OF CHINA" },
    { key: "40160", participant: "BANCO S3" },
    { key: "90600", participant: "MONEXCB" },
    { key: "90601", participant: "GBM" },
    { key: "90602", participant: "MASARI" },
    { key: "90605", participant: "VALUE" },
    { key: "90608", participant: "VECTOR" },
    { key: "90616", participant: "FINAMEX" },
    { key: "90617", participant: "VALMEX" },
    { key: "90620", participant: "PROFUTURO" },
    { key: "90630", participant: "CB INTERCAM" },
    { key: "90631", participant: "CI BOLSA" },
    { key: "90634", participant: "FINCOMUN" },
    { key: "90638", participant: "NU MEXICO" },
    { key: "90642", participant: "REFORMA" },
    { key: "90646", participant: "STP" },
    { key: "90652", participant: "CREDICAPITAL" },
    { key: "90653", participant: "KUSPIT" },
    { key: "90656", participant: "UNAGRA" },
    { key: "90659", participant: "ASP INTEGRA OPC" },
    { key: "90661", participant: "ALTERNATIVOS" },
    { key: "90670", participant: "LIBERTAD" },
    { key: "90677", participant: "CAJA POP MEXICA" },
    { key: "90680", participant: "CRISTOBAL COLON" },
    { key: "90683", participant: "CAJA TELEFONIST" },
    { key: "90684", participant: "TRANSFER" },
    { key: "90685", participant: "FONDO (FIRA)" },
    { key: "90686", participant: "IINVERCAP" },
    { key: "90689", participant: "FOMPED" },
    { key: "90703", participant: "TESORED" },
    { key: "90710", participant: "NVIO" },
    { key: "90722", participant: "Mercado Pago W" },
    { key: "90723", participant: "CUENCA" },
    { key: "90902", participant: "INDEVAL" },
    { key: "90903", participant: "CoDi Valida" },
    { key: "91812", participant: "BBVA BANCOMER*" },
    { key: "91814", participant: "SANTANDER2*" },
    { key: "91821", participant: "HSBC2*" },
    { key: "91927", participant: "AZTECA2*" },
    { key: "91872", participant: "BANORTE2*" },
    { key: "90706", participant: "ARCUS" },
    { key: "91802", participant: "BANAMEX2" }
]


export const beneficiaryAccountType = [
    { key: "3", description: "Tarjeta de debito" },
    { key: "10", description: "Telefono de celular" },
    { key: "40", description: "CLABE" }
]